import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Toaster
            position="top-center"
            containerStyle={{
                top: 72,
                zIndex: 15000,
            }}
            gutter={10}
            toastOptions={{
                duration: 4000,
                className: "text-sm",
                style: {
                    background: "#fff",
                    color: "#1f2937",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    borderRadius: "12px",
                    padding: "12px 16px",
                    maxWidth: "420px",
                    border: "1px solid #f3f4f6",
                },
                success: {
                    duration: 4000,
                    iconTheme: { primary: "#16a34a", secondary: "#fff" },
                },
                error: {
                    duration: 6000,
                    iconTheme: { primary: "#dc2626", secondary: "#fff" },
                },
                loading: {
                    iconTheme: { primary: "#dc2626", secondary: "#fff" },
                },
            }}
        />
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
